export {
  default 
} from "./cutOffText";
